import { AccountBalance, Group, Assessment, Receipt, Analytics, AutoGraph } from '@mui/icons-material';
import { Avatar, Paper, Badge as MuiBadge } from '@mui/material';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import Box from '@mui/material/Box';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function BottomNavBar({ user, isPremium }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  const routeToTab = {
    '/customers': 0,
    '/accounts': 1,
    '/dashboard': 2,
    '/invoices': 3,
    '/reports': 4,
    '/profile': 5,
  };
  const value = routeToTab[location.pathname] ?? -1;

  const handleChange = (_, newValue) => {
    if (newValue === 0) navigate('/customers');
    if (newValue === 1) navigate('/accounts');
    if (newValue === 2) navigate('/dashboard');
    if (newValue === 3) navigate('/invoices');
    if (newValue === 4) navigate('/reports');
    if (newValue === 5) navigate('/profile');
  };

  return (
    <Box sx={{ width: '100%', height: '72px' }}>
      <Paper
        sx={{
          position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 10,
          background: 'var(--bg-card)',
          backdropFilter: 'blur(20px)',
          WebkitBackdropFilter: 'blur(20px)',
          borderTop: '1px solid var(--border-subtle)',
          boxShadow: 'var(--shadow-lg)',
        }}
        elevation={0}
      >
        <BottomNavigation
          value={value}
          onChange={handleChange}
          showLabels
          sx={{
            backgroundColor: 'transparent',
            height: '64px',
            '& .MuiBottomNavigationAction-root': {
              color: 'rgba(136,146,176,0.7)',
              fontFamily: 'Inter, sans-serif',
              fontSize: '11px',
              fontWeight: 500,
              minWidth: 0,
              padding: '6px 8px',
              transition: 'color 0.2s ease',
            },
            '& .Mui-selected': {
              color: '#15C358 !important',
              fontWeight: 600,
            },
            '& .MuiBottomNavigationAction-label': {
              fontSize: '11px !important',
              fontFamily: 'Inter, sans-serif',
              marginTop: '2px',
            },
            '& .MuiSvgIcon-root': {
              fontSize: '22px',
            },
          }}
        >
          <BottomNavigationAction label={t('nav.customers')} icon={<Group />} />
          <BottomNavigationAction label={t('nav.accounts')}  icon={<AccountBalance />} />
          <BottomNavigationAction label={t('nav.dashboard')} icon={<AutoGraph />} />
          <BottomNavigationAction label={t('nav.invoices')} icon={<Receipt />} />
          <BottomNavigationAction 
            label={t('nav.reports')} 
            icon={
              !isPremium ? (
                <MuiBadge badgeContent={<span style={{fontSize:8, color:'#FFD700', fontWeight:800}}>PRO</span>} sx={{ '& .MuiBadge-badge': { background: 'rgba(255,215,0,0.15)', border: '1px solid rgba(255,215,0,0.4)', borderRadius: 1, padding: '0 4px', right: -4, top: 4, height: 16, minWidth: 24 } }}>
                  <Analytics />
                </MuiBadge>
              ) : <Analytics />
            } 
          />
          <BottomNavigationAction
            label="Profile"
            icon={
              <Avatar
                alt={user?.displayName}
                src={user?.photoURL}
                sx={{
                  width: 26, height: 26,
                  border: value === 5 ? '2px solid #15C358' : '2px solid transparent',
                  transition: 'border-color 0.2s ease',
                }}
              />
            }
          />
        </BottomNavigation>
      </Paper>
    </Box>
  );
}